import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdvancedFilterProject } from '../../models/advanced-filter';
import { Constants } from '../../utils/constants';

@Component({
  selector: 'app-duplicated-combination-dialog',
  templateUrl: './duplicated-combination-dialog.component.html',
  styleUrls: ['./duplicated-combination-dialog.component.css']
})
export class DuplicatedCombinationDialogComponent {

  @Input() formulationName: string = "";
  @Input() geographyName: string = "";
  @Input() projects: AdvancedFilterProject[] = [];

  @Output() onCloseEvent = new EventEmitter<void>();
  @Output() onProjectSelectedEvent = new EventEmitter<number>();

  public visible: boolean = true;
  public readonly texts = Constants.DUPLICATED_COMBINATION_DIALOG;

  public close(): void {
    this.onCloseEvent.emit();
  }

  public selectProject(projectPk?: number): void {
    if (!projectPk || projectPk < 0) return;
    this.onProjectSelectedEvent.emit(projectPk);
  }
}
